module.exports = {
  topicExam: {
    title: "考试",
    requiredParams: {
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id"
      // againFlag: "是否为重新挑战(1:重新挑战, 0:不是,不能未空)"
    },
    optionalParams: {}
  },
  topicExamDetails: {
    title: "考试详情",
    requiredParams: {
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id"
    },
    optionalParams: {
      questionId:
        "题目的ID,用来定位到某个题目(不传或没有找到题目ID都是从第一题开始)",
      errorOrCorrect: "1看全部，2只看正确，3只看错误"
    }
  },
  topicExamResult: {
    title: "考试结果",
    requiredParams: {
      testPaperId: "试卷id",
      testPaperNo: "试卷编号",
      testingId: "测评id"
    },
    optionalParams: {}
  },
  topicWrong: {
    title: "错题本",
    requiredParams: {},
    optionalParams: {}
  },
  studyData: {
    title: "学习数据",
    requiredParams: {},
    optionalParams: {}
  },
  service: {
    title: "我的客服",
    requiredParams: {},
    optionalParams: {}
  },
  personalInfo: {
    title: "个人信息",
    requiredParams: {},
    optionalParams: {}
  },
  convertDetail: {
    noLoginRequired: true,
    title: "兑换详情页",
    requiredParams: {
      id: "卡券的Id"
    },
    optionalParams: {}
  },
  orderDetail: {
    title: "订单详情",
    requiredParams: {
      orderId: "订单主键",
      orderNo: "订单编号",
      isFailed: ""
    },
    optionalParams: {}
  },
  order: {
    title: "已购",
    requiredParams: {},
    optionalParams: {}
  },
  coupon: {
    title: "我的券包",
    requiredParams: {},
    optionalParams: {}
  },
  collection: {
    title: "我的收藏",
    requiredParams: {},
    optionalParams: {}
  },
  map: {
    title: "选择机构/医院",
    noLoginRequired: true,
    requiredParams: {},
    optionalParams: {}
  },
  changePhone: {
    title: "更换手机号",
    requiredParams: {},
    optionalParams: {}
  },
  mineIndex: {
    title: "我的",
    requiredParams: {},
    optionalParams: {}
  },
  realName: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {}
  },
  mineExam: {
    title: "我的考试",
    requiredParams: {},
    optionalParams: {}
  },
  testInstructions: {
    title: "考试须知",
    requiredParams: {},
    optionalParams: {}
  },
  convertPage: {
    title: "兑换列表",
    requiredParams: {
      courseSystemId: ""
    },
    optionalParams: {}
  },
  setting: {
    title: "设置",
    requiredParams: {},
    optionalParams: {}
  },
  editPasswordSendCode: {
    title: "修改密码",
    requiredParams: {},
    optionalParams: {}
  },
  editPassword: {
    title: "设置密码",
    requiredParams: {},
    optionalParams: {}
  },
  realNameError: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {}
  },
  realNameSuccess: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {}
  },
  realNameNew: {
    title: "实名认证",
    requiredParams: {},
    optionalParams: {
      realNameStatus: "" //1:审核通过 2:审核未通过 3:待审核,4用户没有认证记录
    }
  }
};
